import { useQuery } from "@tanstack/react-query";
import { listSections } from "./sections-api";
// SECTIONS_KEY is declared in use-runs.ts so the run mutation can invalidate
// the sections cache without dragging in a circular import. We re-import it
// here (and re-export for convenience) rather than redeclaring — keeping a
// single source of truth for the cache key.
import { SECTIONS_KEY } from "./use-runs";

export { SECTIONS_KEY };

/**
 * TanStack Query hook for the sections list of a single schedule. Mirrors the
 * shape of {@link useScheduleIssues} / {@link useRuns}: keyed on `scheduleId`,
 * disabled while the id is empty (e.g. before the route param resolves).
 *
 * The `assignedCount` field on each row reflects the **latest succeeded run**.
 * Pre-first-run schedules see `assignedCount = null`; the Sections table
 * renders these as an em-dash so a freshly imported schedule isn't visually
 * indistinguishable from one whose run produced zero placements.
 */
export function useSections(scheduleId: string) {
  return useQuery({
    queryKey: SECTIONS_KEY(scheduleId),
    queryFn: () => listSections(scheduleId),
    enabled: !!scheduleId,
  });
}
